import React from 'react';
import { blue, lightBlue } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { Add, Remove } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { FormSectionHeaderProps } from './types';

export const FormSectionHeader = <Value extends string>({
  name,
  value,
  extraAction,
  handleUpdateCollapse,
  isSectionOpen = true,
  handleUpdateOpenStatus,
  isSectionCollapsed = false,
  sx = {},
}: FormSectionHeaderProps<Value>) => {
  const classes = useStyles();

  return (
    <Box style={sx} className={classes.sectionHeader}>
      <Box className="collapse">
        {!!handleUpdateOpenStatus && (
          <IconButton
            size="small"
            sx={{ padding: '0.25rem' }}
            onClick={() => handleUpdateOpenStatus(value, !isSectionOpen)}
          >
            {isSectionOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
          </IconButton>
        )}

        {!!handleUpdateCollapse && (
          <IconButton
            size="small"
            sx={{ padding: '0.25rem' }}
            onClick={() => handleUpdateCollapse(value, !isSectionCollapsed)}
          >
            {isSectionCollapsed ? <Add fontSize="small" /> : <Remove fontSize="small" />}
          </IconButton>
        )}

        {name && (
          <Typography component="span" variant="subtitle2">
            {name}
          </Typography>
        )}
      </Box>

      {extraAction && extraAction}
    </Box>
  );
};

const useStyles = makeStyles({
  sectionHeader: {
    display: 'flex',
    minHeight: '56px',
    borderRadius: '2px',
    position: 'relative',
    padding: '13px 16px',
    alignItems: 'center',
    backgroundColor: blue['50'],
    justifyContent: 'space-between',

    '& .collapse': {
      gap: '8px',
      display: 'flex',
      alignItems: 'center',
    },

    '& .actionPanel': {
      gap: '8px',
      display: 'flex',
      alignItems: 'center',
    },

    '& .MuiButton-contained': {
      color: lightBlue['800'],
      borderRadius: 'var(--borderRadius, 4px)',
      background: 'var(--common-white_states-main, #FFF)',
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
      '&.Mui-disabled': {
        boxShadow: 'none',
        color: lightBlue['700'],
      },
    },
  },
});
